import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { fetchUserDetails } from 'queries/getUserDetailsQuery'
import { UserDetailsFetchProps } from 'types/api'
import { useAnalytics } from 'utils/analytics'
import { TIME } from 'utils/misc'

export function useUserDetails({
    env,
    accessToken,
    lanId,
}: UserDetailsFetchProps) {
    const { trackEvent } = useAnalytics()
    const { data, isLoading, isError, error, refetch } = useQuery(
        [QueryKeys.USER_DETAILS],
        () =>
            fetchUserDetails({
                env,
                accessToken,
                filters: {
                    lan_id: lanId,
                },
                trackEvent,
            }),
        {
            staleTime: TIME.oneHour,
            cacheTime: TIME.oneHour,
            enabled: !!accessToken && !!lanId,
        },
    )

    return { data, isLoading, isError, error, refetch }
}
